import { useContext } from 'react';
import { ScanDataContext, ScanDataState } from '../context/ScanDataContext';

// Custom hook to use the ScanData context
const useScanData = (): ScanDataState => {
  const context = useContext(ScanDataContext);
  if (context === undefined) {
    throw new Error('useScanData must be used within a ScanDataProvider');
  }
  return context;
};

export default useScanData;
